<template>
  <div class="container">
    <h2 class="mb-xs">{{ headline }}</h2>
    <p>{{ text }}</p>
  </div>
</template>

<script setup>
const props = defineProps({
  headline: String,
  text: String,
});
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  gap: map-get($spaces, "xs");
}
</style>
